import http from "@/settings/apiSettings"

class PORTAL_ProfilService {
  get(): Promise<any> {
    return http.clientPortalHR.get("/portal/profil", {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  update(data: { Email?: string; Telefon?: string }): Promise<any> {
    return http.clientPortalHR.patch("/portal/profil", data, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }
}

export default new PORTAL_ProfilService();
